import api from "../../utils/ApiConfig";

export const fetchSignupRiskChecksData = async (page = 1, searchTerm = "", filters = {}) => {
  try {
    const response = await api.get(`/bo/signup-risk-checks`, {
      params: {
        page: page,
        per_page: 50,
        email: searchTerm,
        ...filters,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching signup risk checks data:", error);
    throw error;
  }
};
